import React, { Fragment }from 'react'
import { Table, Button, Col, Row } from 'react-bootstrap'

function PriceBreakdown(props) {
  const {
    selected_program,
    pricingBreakdown,
    FormikValues,
    displayPaymentFormFn,
    enrolInMoreLeagues,
    priceElements,
    leagueOptions,
    confirm_spinner,
    disabled,
    instalment_number,
    validationMessage,
    promotionCodeField,
    waiverField,
  } = props
  console.log('PriceBreakdown props', props)
  var instalments = [];
  const formatAmount = (amount) => {
    const numericAmount = Number(amount) || 0;
    return numericAmount % 1 === 0 ? numericAmount : numericAmount.toFixed(2);
  };
  const promoCodeValue = pricingBreakdown.promo_code;
  const promoDiscountAmount = Math.abs(
    Number(
      typeof promoCodeValue === "string"
        ? promoCodeValue.replace(/[^0-9.-]/g, "")
        : promoCodeValue
    ) || 0
  );
  const subtotalAmount = Math.max(
    (Number(pricingBreakdown.total) || 0) + promoDiscountAmount,
    0
  );

  if (instalment_number !==1 && selected_program.length > 0 ) {
    selected_program.forEach(program => {
      instalments.push(<td className="price-element"><strong>${pricingBreakdown[program._id].instalment_total % 1 === 0 ? pricingBreakdown[program._id].instalment_total : pricingBreakdown[program._id].instalment_total.toFixed(2)}</strong></td>)
    })
  }
  
  return (
    <>
      <div>
        <Col lg={12} className="price-breakdown-table">
          <div className="enrolment-subcard enrolment-subcard-inline enrolment-pricebreakdown-card">
            <div className="enrolment-section-header">
              <div className="enrolment-section-kicker">Checkout</div>
            </div>
            <div className="price-breakdown-table-shell">
            <Table className="pb-table enrolment-pricebreakdown-table" responsive>
                <colgroup>
                  <col className="price-breakdown-label-col" />
                  <col className="price-breakdown-value-col" />
                </colgroup>
                <thead>
                  <tr>
                    <th style={{width: "70%" }}></th>
                    <th style={{width: "30%" }}></th>
                  </tr>
                </thead>
                <tbody>
                  {
                    // for EF1
                    !selected_program ?
                      <tr>
                        <td className="price-breakdown-label-cell">EF1 - Sign Up to Hoopstir</td>
                        <td className="price-element price-breakdown-value-cell">${pricingBreakdown.plan_price}</td>
                      </tr>
                    :
                    // for EF2 
                    selected_program.length > 0 ? // for multi-league checkout
                    selected_program.map(league => {
                      if (pricingBreakdown[league._id]) {
                        return (
                          <Fragment key={league._id}>
                            <tr>
                              <td className="price-breakdown-label-cell">{league.ages} {league.division} {league.group_name}</td>
                              <td className="price-element price-breakdown-value-cell"></td>
                            </tr>
                            {priceElements[league._id]}
                          </Fragment>
                        )
                      }
                    })
                  :
                  // for EF3
                    <Fragment key={selected_program._id}>
                      <tr>
                        <td className="price-breakdown-label-cell">{selected_program.group_name} ({selected_program.ages} {selected_program.division})</td>
                        <td className="price-element price-breakdown-value-cell">${pricingBreakdown.plan_price}</td>
                      </tr>
                      {priceElements}
                    </Fragment>
                  }
                  {
                    pricingBreakdown.processing_fee > 0 ?
                      <tr>
                        <td className="price-breakdown-label-cell">Processing Fee</td>
                        <td className="price-element price-breakdown-value-cell"><strong>${pricingBreakdown.processing_fee.toFixed(2)}</strong></td>
                      </tr>
                      : ""
                  }
                    <tr className="price-breakdown-subtotal-row">
                      <td className="price-breakdown-label-cell">Subtotal</td>
                      <td className="price-element price-breakdown-value-cell"><strong>${formatAmount(subtotalAmount)}</strong></td>
                    </tr>
                  {
                    promotionCodeField ? (
                      <tr className="price-breakdown-discount-row">
                        <td className="price-breakdown-label-cell">Discount code</td>
                        <td className="price-breakdown-discount-cell">
                          {promotionCodeField}
                        </td>
                      </tr>
                    ) : null
                  }
                    <tr className="price-breakdown-total-row">
                      <td className="price-breakdown-label-cell">Total</td>
                      <td className="price-element price-breakdown-value-cell"><strong>${formatAmount(pricingBreakdown.total)}</strong></td>
                    </tr>
                  {
                    instalment_number !== 1 &&                                     
                  <tr className="price-breakdown-instalment-row">
                    <td className="price-breakdown-label-cell">
                      Instalment 1 of {instalment_number}
                    </td>
                    {
                      selected_program.length > 0 ?
                      instalments
                      :
                      <td className="price-element price-breakdown-value-cell"><strong>${formatAmount(pricingBreakdown.instalment_total)}
                      </strong></td>
                    }
                    </tr>
                  }
                </tbody>
              </Table>
              {waiverField}
            </div>
          </div>
        </Col>
      </div>
      <Row className="enrolment-row">
        {
          !props.displayPaymentForm ?
            confirm_spinner ? 
              <div style={{textAlign: "center"}}>
                <div className="enrolment-loader"></div>
              </div> 
              :
              selected_program && selected_program.length > 0 ?
                confirm_spinner ?
                <div style={{textAlign: "center"}}>
                  <div className="enrolment-loader"></div>
                </div> 
                :
                <div style={{textAlign: "center"}}>
                  {
                    props.waitlistInitialSignup && !props.waitlistTransaction ?
                    <Button className="button2 pay-button" onClick={props.joinWaitlist}>
                      Join Waitlist
                    </Button> 
                    :
                    <div className="league-pricebreakdown">
                      { selected_program.length !== leagueOptions &&
                        <Button style={{marginBottom: '0.5em', display: 'none'}} className="button2 pay-button" onClick={() => enrolInMoreLeagues()} disabled={disabled}>
                          Enrol in more Leagues
                        </Button>
                      }

                      <div className="price-breakdown-action-row">
                        <Button style={{marginBottom: '0.5em'}} className="button2 pay-button" onClick={() => displayPaymentFormFn(FormikValues)}>
                          Proceed to Checkout
                        </Button>
                      </div>
                    </div>
                  }
                </div>
              :
              <>
                {
                  props.waitlistInitialSignup && !props.waitlistTransaction ?
                  <Button className="button2 pay-button" onClick={props.joinWaitlist}>
                    Join Waitlist
                  </Button> :
                  <div className="price-breakdown-action-row">
                    <Button className="button2 finalbtn" onClick={() => displayPaymentFormFn(FormikValues)}>
                      Proceed to Checkout
                    </Button>
                  </div>
                }
              </>
            : 
            ""
        }   
      </Row>
    </>
  )
}

export default PriceBreakdown
